import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// CRA inlines REACT_APP_* at build time, so this is either a real DSN or
// undefined in every build that doesn't set it (local dev, CI, and any
// deploy before the REACT_APP_SENTRY_DSN repo variable is configured).
// Sentry.init() is a no-op call when dsn is undefined -- nothing is sent
// and no network activity occurs -- so this stays silent by default.
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.REACT_APP_GIT_SHA,
    environment: 'production',
    // Low sample rate keeps this well inside the free tier; errors are
    // still captured at 100% regardless of this setting.
    tracesSampleRate: 0.1,
    // No session replay integration is added -- it's heavier than needed
    // here and not requested. Default PII scrubbing stays on (we do NOT
    // set sendDefaultPii) since the RSVP form collects guest emails/phone
    // numbers that must never be shipped to Sentry.
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
